import { render, staticRenderFns } from "./ComputerSalesProgramsAdd.vue?vue&type=template&id=76aa55c0"
import script from "./ComputerSalesProgramsAdd.vue?vue&type=script&lang=js"
export * from "./ComputerSalesProgramsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports